import { EmptyState } from "@drs-ops/ui/feedback";
import { LayoutDashboard } from "lucide-react";

export function Landing(): React.ReactElement {
  return (
    <div className="mx-auto max-w-2xl p-6">
      <EmptyState
        icon={LayoutDashboard}
        title="DRS Estimator"
        description="Shell online. The Travel module arrives in Phase 1, followed by the Estimator Core in Phase 2."
      />
    </div>
  );
}
